// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const zh: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': '游戏玩法',
  'howto.pieces.heading': '部件',
  'howto.pieces.source': '光源',
  'howto.pieces.mirror': '镜子',
  'howto.pieces.switch': '开关',
  'howto.pieces.exit': '出口',
  'howto.pieces.wall': '墙壁',
  'howto.controls.heading': '操作',
  'howto.controls.clickSlot.line1': '点击格子',
  'howto.controls.clickSlot.line2': '放置镜子',
  'howto.controls.dragMirror.line1': '拖动镜子',
  'howto.controls.dragMirror.line2': '旋转',
  'howto.controls.rightClick.line1': '右键点击',
  'howto.controls.rightClick.line2': '移除镜子',
  'howto.controls.hint': '鼠标滚轮:精细旋转 1°。   点击镜子:旋转 15°。',
  'howto.objective.line1': '点亮每个开关——出口的锁会自动弹开。',
  'howto.objective.line2': '然后点击出口。用尽量少的镜子解开谜题。',

  'howtoColor.title': '颜色与棱镜',
  'howtoColor.pieces.heading': '新部件',
  'howtoColor.pieces.prism': '棱镜',
  'howtoColor.pieces.redSwitch': '红色开关',
  'howtoColor.pieces.yellowSwitch': '黄色开关',
  'howtoColor.pieces.whiteSwitch': '白色开关',
  'howtoColor.how.heading': '工作原理',
  'howtoColor.how.line1': '白色光束同时携带红、绿、蓝三种光。',
  'howtoColor.how.line2': '棱镜沿其三条边将白光分成三道有色光束。',
  'howtoColor.how.line3': '点击已放置的棱镜可旋转其输入面。',
  'howtoColor.switches.line1': '开关上有彩色圆点——那就是它需要的颜色。',
  'howtoColor.switches.line2': '黄色开关(红 + 绿)需要两种颜色同时到达。',
  'howtoColor.switches.line3': '白色开关(三色齐全)需要红、绿和蓝同时到达。',

  'options.hints.label': '在谜题中显示提示角度',
  'options.hints.help': '显示每次反射时入射光线与反射光线之间的夹角。',

  'level.01-intro.title': '你好,光',
  'level.02-two-mirrors.title': '两次转弯',
  'level.03-corner.title': '挡路的墙',
  'level.04-two-targets.title': '两个目标',
  'level.05-tight.title': '狭窄',
  'level.06-hello-color.title': '你好,颜色',
  'level.07-pick-a-side.title': '选一边',
  'level.08-yellow.title': '黄色',
  'level.09-magenta.title': '品红',
  'level.10-spectrum.title': '光谱',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': '直角',
  'puzzle.hint.angleType.acute': '锐角',
  'puzzle.hint.angleType.obtuse': '钝角',
  'puzzle.hint.label': '{angle}°\n{type}',
};
